<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('documents')" :isNewButton="checkPermission('staff_upload')"
                        @new-button-click="createFormShow()" :isFilter="false">
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('documents')" :isNewButton="checkPermission('staff_upload')"
                              @new-button-click="createFormShow()"
                              :isFilter="false"
                >
                </HeaderMobile>
            </template>
            <datatable :isLoading.sync="datatable.isLoading" :columns="datatable.columns" :rows="datatable.rows"
                       :total="datatable.total" :queryParams="datatable.queryParams" @on-page-change="onPageChange"
                       @on-sort-change="onSortChange" @on-per-page-change="onPerPageChange" v-show="datatable.showTable">
            </datatable>
            <CommonModal ref="createFormModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('new').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <document-create @createFormSuccess="createFormSuccess" :formId="id" v-if="formProcess == 'create'" />
                </template>
            </CommonModal>
            <CommonModal
                ref="showModal"
                size="xl"
                :onHideOnlyX="true"
                @bHideModalHeaderClose="formClear()"
                v-if="checkPermission('staff_show')"
            >
                <template v-slot:CommonModalTitle>
                    {{ $t("show").toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <document-show :formId="id" :docUuid="docUuid" v-if="formProcess == 'show'" />
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout.vue"
import Header from "@/layouts/AppLayout/Header.vue"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile.vue"

// Components
import Datatable from "@/components/datatable/Datatable.vue";
import CommonModal from "@/components/elements/CommonModal.vue";

// Pages
import DocumentCreate from "./Information/components/documents/DocumentCreate.vue";
import DocumentShow from "./Information/components/documents/DocumentShow.vue";

// Services
import StaffService from "@/services/StaffService";

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,
        Datatable,
        CommonModal,
        DocumentCreate,
        DocumentShow,
    },
    metaInfo() {
        return {
            title: this.$t('documents')
        }
    },
    data() {
        return {
            id: this.$route.params.id,
            data: null,
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: '',
                        field: 'buttons',
                        html: true,
                        sortable: false,
                        tdClass: 'p-0 text-center w-40 align-middle',
                        buttons: [
                            {
                                text: this.$t('download'),
                                permission: "staff_download",
                                class: 'ri-file-download-line align-middle top-minus-1 mr-3 text-muted',
                                callback: (row) => {
                                    this.downloadFile(row)
                                },
                            },
                            {
                                text: this.$t('show'),
                                class: 'ri-search-eye-line align-middle top-minus-1 mr-3 text-muted',
                                permission: 'staff_show',
                                callback: (row) => {
                                    this.showFormShow(row.id, row.uuid);
                                }
                            },
                            {
                                text: this.$t('delete'),
                                class: 'ri-delete-bin-7-line align-middle top-minus-1 mr-3 text-muted',
                                permission: "staff_deletefile",
                                callback: (row) => {
                                    this.formDelete(row)
                                }
                            },
                        ]
                    },
                    {
                        label: this.toUpperCase('id'),
                        field: 'id',
                        hidden: true,
                    },
                    {
                        label: this.toUpperCase('created_at'),
                        field: 'created_at',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('type'),
                        field: 'type',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('description'),
                        field: 'description',
                        hidden: false,
                    },
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: 'id',
                    page: 1,
                    limit: 20
                }
            },
            formProcess: null,
            formId: null,
            docUuid: null,
            form: {},
            academic_year: null
        }
    },
    created() {
        this.getDocument()
    },
    computed: {

    },
    methods: {
        filter() {
            this.datatable.queryParams.page = 1;
            this.getDocument();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getDocument();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getDocument();
        },
        changeColumn(key) {
            this.datatable.columns[key].hidden = this.datatable.columns[key].hidden == true ? false : true;
        },
        onSortChange(params) {
            const sortType = params[0].type == 'desc' ? '-' : '';
            this.datatable.queryParams.sort = sortType + params[0].field
            this.getDocument();
        },
        getDocument() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;


            return StaffService.document(this.id)
                .then((response) => {
                    this.datatable.rows = response.data.data
                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },
        // Clear
        formClear() {
            this.formId = null
            this.formProcess = null
        },
        showFormShow(id, docUuid) {
            this.formId = id
            this.docUuid = docUuid
            this.formProcess = 'show'
            this.$refs.showModal.$refs.commonModal.show()
        },
        // Create
        createFormShow() {
            this.formId = null
            this.formProcess = 'create'
            this.$refs.createFormModal.$refs.commonModal.show()
        },
        createFormSuccess() {
            this.$refs.createFormModal.$refs.commonModal.hide()
            this.getDocument()
            this.formClear()
        },
        formDelete(item) {
            this.$swal
                .fire({
                    text: this.$t('are_you_sure_to_delete'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no'),
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        StaffService.documentDelete(item.uuid)
                            .then(response => {
                                this.$toast.success(this.$t('api.' + response.data.message));
                                this.getDocument();
                                this.formClear();
                            })
                            .catch(error => {
                                this.$toast.error(this.$t('api.' + error.data.message));
                            });
                    }
                })
        },
        downloadFile(item) {
            StaffService.downloadFile(item.uuid)
                .then(response => {
                    if (response.headers['content-type'] === 'application/pdf') {
                        EventBus.$emit('pdfViewerModalShow', {pdfFileData: response.data, pdfFileName: item.file_name});
                    } else {
                        this._downloadFile(response, item.file_name)
                    }
                }).catch(err => {
                    this.showErrors(err)
                })
        },
    }
}
</script>

